import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'

import { downloadPaySlip } from 'services/api/payslip'
import Login from 'pages/login/view/Login'
import { downloadBlobFile, notifyDownloadError } from 'services/helper/fileDownload'
import { hasHrAccessToken } from 'services/session/authSession'

export default function PaySlipDownload() {
  const isAuth = hasHrAccessToken()

  const params = useParams()

  const viewFile = async () => {
    try {
      const res = await downloadPaySlip(params.id)

      const pdfBlob = await axios.get(res.data.attachment, { responseType: 'blob' })

      downloadBlobFile({
        data: pdfBlob.data,
        fileName: res.data.name,
        contentType: pdfBlob.headers?.['content-type'],
        successMessage: 'Payslip downloaded.',
      })
    } catch (error) {
      notifyDownloadError('Unable to download payslip. Please try again.')
      if (error.status === 404) {
        const errorNew = new Error()
        errorNew.status = error.status
        errorNew.data = {
          message: 'Download fail. Please confirm you are using correct email id.',
        }
        throw errorNew
      } else {
        throw error
      }
    }
  }

  useEffect(() => {
    if (isAuth) {
      viewFile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Login download={viewFile} />
}
